var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"资料列表","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('myData',{attrs:{"dataList":_vm.dataList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }